export default class BuyersForm {
    constructor($el) {
        this.$el = $el;
        this.$modalContainer = this.$el.querySelector('[data-modal-container]');
        this.$modal = this.$el.querySelector('[data-modal]');
        this.$btn = this.$el.querySelector('[data-open-modal-form]');
        this.$select = this.$el.querySelector('[data-select-projects]');
        this.$error = this.$el.querySelector('.form__group--error');

        this.openModal = this.openModal.bind(this);
        this.openModalFromError = this.openModalFromError.bind(this);

        this.$btn.addEventListener('click', this.openModal);

        if (this.$error) {
            this.openModalFromError();
        }
    }

    openModal(e) {
        e.preventDefault();
        this.$modalContainer.classList.add('modal__container--open');
        this.$modal.classList.add('modal--open');
    }

    openModalFromError() {
        this.$modalContainer.classList.add('modal__container--open');
        this.$modal.classList.add('modal--open');
    }
}